module.exports = "https://beta.voredev.ru/assets/index/instagram-mini-61ded5dace5ec3110f1da350771a5364.svg";